// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1WSaZ","outer2":"_3y_jU","buyWithConfidenceImage":"elspb","title":"_2zZ3n","subtitle":"_1O-tH"};